import React, { useState } from 'react';
import '../styles/HomePage.css'; 
import '../styles/Sobre.css'; 
import felipeImage from '../img/felipe.jpg';
import DamiresImage from '../img/damires.png';
import alexImage from '../img/alex.png';
import pabloImage from '../img/pablo.jpeg';
import lucasImage from '../img/lucas.png';
import ayrtonImage from '../img/ayrton.png';
import robertoImage from '../img/roberto.jpeg';

function AboutPage() {
  const [activeCard, setActiveCard] = useState(null);

  const teamMembers = [
    {
      name: "Felipe Targino",
      img: felipeImage, 
      role: "Graduando em Tecnologia em Sistemas para Internet",
      description: "Membro do Grupo SIDE.",
      email: "felipe.targino@academico.ifpb.edu.br",
      linkedin: "https://www.linkedin.com/in/felipe-targino/",
      github: "https://github.com/targinofelipe1"
    },
    {
      name: "Ayrton Douglas Rodrigues Herculano",
      img: ayrtonImage, 
      role: "Mestre em Tecnologia da Informação / Graduado em Sistemas para Internet",
      email: "ayrton.herculano@academico.ifpb.edu.br",
      linkedin: "https://www.linkedin.com/in/ayrtondouglas/",
      github: "https://github.com/ayrtonherculano"
    }, 
    {
      name: "Lucas Andrade dos Santos",
      img: lucasImage,  
      role: "Graduando em Sistemas para Internet",
      email: "lucas.santos.18@academico.ifpb.edu.br",
      linkedin: "https://www.linkedin.com/in/lucasandrade912",
      github: "https://github.com/LucasAndrade912"
    },
    {
      name: "Pablo de Lima Marques Estrela",
      img: pabloImage,  
      role: "Graduando em Sistemas para Internet",
      email: "pablo.estrela@academico.ifpb.edu.br",
      linkedin: "https://www.linkedin.com/in/pablo-estrela/",
      github: "https://github.com/eztrela"
    },
    {
      name: "Damires Souza",
      img: DamiresImage,
      role: "Professora e Pesquisadora no IFPB/SIDE",
      description: "Coordenadora do projeto.",
      email: "damires@ifpb.edu.br",
      linkedin: "https://www.linkedin.com/in/damires-souza/",
    },
    {
      name: "Alex Sandro Cunha",
      img: alexImage,
      role: "Professor e Pesquisador no IFPB/SIDE",
      email: "alex.cunha@ifpb.edu.br",
      linkedin: "https://www.linkedin.com/in/alex-cunha/",
      github: "https://github.com/alexcunha"
    },
  ];

  const partnershipMembers = [
    {
      name: "Dr. Roberto Mendes",
      img: robertoImage,
      role: "Psiquiatra, HU-UFPB/EBSERH",
      description: "Colaborador do projeto.",
      email: "roberto.mendes@ufpb.br",
    }
  ];

  const handleCardClick = (index, type) => {
    setActiveCard(activeCard === index ? null : index);
  };

  return (
    <div>
      
      <div className="sobrepage-container">
        <div className="homepage-text">
          <h2>Sobre a Bem te Vejo</h2>
          <p>
            A Bem te Vejo foi desenvolvida pelo grupo de pesquisa SIDE (Semantics, Intelligence and Data Ecosystems) do IFPB - Campus João Pessoa. A aplicação utiliza dados do Reddit e de outros conjuntos abertos, como os disponíveis no repositório Kaggle.
          </p>
          <p>
            A Bem te Vejo tem como objetivo fornecer análises detalhadas sobre como a depressão foi discutida em redes sociais, especialmente durante a pandemia de COVID-19, oferecendo insights valiosos para estudos de saúde mental.
          </p>
          <p>
            Para mais informações, entre em contato com <a href="mailto:side@ifpb.edu.br">side@ifpb.edu.br</a>.
          </p>
        </div>
      </div>

      <div className="team-container">
        <h2>Time de Desenvolvimento</h2>
        <div className="team-grid">
          {teamMembers.map((member, index) => (
            <div 
              key={index} 
              className={`team-card ${activeCard === index ? 'active' : ''}`} 
              onClick={() => handleCardClick(index, 'team')}
            >
              <img src={member.img} alt={member.name} className="team-image" />
              <h3>{member.name}</h3>
              <p>{member.role}</p>
              <p>{member.description}</p>
              <div className="team-details">
                <p><strong>E-mail:</strong> <a href={`mailto:${member.email}`}>{member.email}</a></p>
                {member.linkedin && <p><strong>LinkedIn:</strong> <a href={member.linkedin} target="_blank" rel="noopener noreferrer">Visitar Perfil</a></p>}
                {member.github && <p><strong>GitHub:</strong> <a href={member.github} target="_blank" rel="noopener noreferrer">Visitar Repositório</a></p>}
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="team-container">
        <h2>Parceria</h2>
        <div className="single-partner-grid"> 
          {partnershipMembers.map((member, index) => (
            <div 
              key={index} 
              className={`single-partner-card ${activeCard === index ? 'active' : ''}`} 
              onClick={() => handleCardClick(index, 'partnership')}
            >
              <img src={member.img} alt={member.name} className="team-image" />
              <h3>{member.name}</h3>
              <p>{member.role}</p>
              <p>{member.description}</p>
              <div className="team-details">
                <p><strong>E-mail:</strong> <a href={`mailto:${member.email}`}>{member.email}</a></p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default AboutPage;
